import $ from "jquery";
import ko from "knockout";
import { registerKnockoutBinding } from "flow/knockout/register";

registerKnockoutBinding("smartAutoScroll", {
    update(element: HTMLElement, valueAccessor: () => KnockoutObservable<any>) {
        const selected = ko.unwrap(valueAccessor());

        // Correction to get bottom border of item into view when scrolling.
        const pixelCorrection = 2;

        // Value 0 will bring item fully into view.
        // An alternative would be - element.offsetHeight.
        // It would skip scrolling a partially visible item.
        const scrollUpThreshold = 0;

        if (!selected) {
            return;
        }

        requestAnimationFrame(() => {
            const scrollParent = $(element).scrollParent()[0];

            // We need to make sure element offsetTop is relative to scroll parent.
            const elementOffsetTop =
                scrollParent === element.offsetParent ? element.offsetTop : element.offsetTop - scrollParent.offsetTop;

            const elementStart = elementOffsetTop - scrollParent.scrollTop;
            const elementEnd = elementOffsetTop - scrollParent.scrollTop + element.offsetHeight;

            if (elementStart < scrollUpThreshold) {
                scrollParent.scrollTop = elementOffsetTop;
            } else if (elementEnd > scrollParent.clientHeight) {
                scrollParent.scrollTop =
                    elementOffsetTop + element.offsetHeight - scrollParent.clientHeight + pixelCorrection;
            }
        });
    }
});
